import { render, staticRenderFns } from "./Academic.html?vue&type=template&id=69cc5f27&scoped=true&external"
import script from "./Academic.vue?vue&type=script&lang=js"
export * from "./Academic.vue?vue&type=script&lang=js"
import style0 from "./Academic.scss?vue&type=style&index=0&id=69cc5f27&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cc5f27",
  null
  
)

export default component.exports